import { ReactElement } from 'react'

import InternalLink from '~/main_app/components/InternalLink'

interface TextWithLinkProps {
  textContainerClassName?: string
  text?: string
  linkLabel: string
  href: string
}

export function TextWithLink (props: TextWithLinkProps): ReactElement {
  const { text, linkLabel, href, textContainerClassName } = props

  return (
    <div className={textContainerClassName}>
      <p>{text ?? ''}<InternalLink href={href}>{linkLabel}</InternalLink></p>
    </div>
  )
}
